import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash';

import useMediaQuery from '@mui/material/useMediaQuery';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { handleApiRequest } from '../../../api';
import useApiError from '../../../hook/useApiError';

import SelectProduct from './SelectProduct';
import { LOADING_MSG } from '../constants';

import Loading from '../../../components/loading/Loading';
import NormalTable from '../../../components/table/NormalTable';
import { tableColumnsDefined } from '../../../components/table/tableDefined';
import { handleTableQuery } from '../../../components/table/tableQuery';
import { NavigateBeforeIcon } from '../../../components/customStyles/images';

import { PAGE } from '../../../constants/url';

import theme from '../../../theme';


const ProductList = (props) => {
  const navigate = useNavigate();
  const { handleApiErrorStatus } = useApiError();
  const [isLoading, setIsLoading] = useState(true);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [isSearchTriggered, setIsSearchTriggered] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sort, setSort] = useState({ sort_by: "", sort_order: "DESC" });
  const [productList, setProductList] = useState([]);
  const [sortProductList, setSortProductList] = useState([]);
  const [pagination, setPagination] = useState({});
  const [selectedProduct, setSelectedProduct] = useState(null);
  const isMoblie = useMediaQuery(theme.breakpoints.down('md'));
  const currentTableColumnsDefined = tableColumnsDefined['productList'];

  const getProductList = useCallback(() => {
    setIsLoading(true);

    const params = new URLSearchParams({
      search_phrase: searchKeyword.trim(),
      page: page,
      size: rowsPerPage
    })

    handleApiRequest('getProductList', params)
      .then(res => {
        if (res.status === 200) {
          const resultData = res.data.result;
          setProductList(resultData);
          setSortProductList(resultData);
          setPagination(res.data.pagination);
          setIsLoading(false);
        } else {
          handleApiErrorStatus(res);
        }
      })
  }, [page, rowsPerPage, searchKeyword])

  useEffect(() => {
    getProductList();
  }, [rowsPerPage, page]);

  useEffect(() => {
    if (!searchKeyword) {
      setIsSearchTriggered(false);
      setPage(0);
      if (page === 0) {
        getProductList();
      }
    }
  }, [searchKeyword]);

  const handelSearchActive = () => {
    if (searchKeyword) {
      setIsSearchTriggered(true);
      setPage(0);
      if (page === 0) {
        getProductList();
      }
    }
  }

  const handelSearchKeyDown = (e) => {
    if (e.key === 'Enter') {
      handelSearchActive();
    }
  }

  const handleTableAction = (e, { id, data }) => {
    if (id === 'product_select') {
      setSelectedProduct({
        product_title: data.product_title,
        identity: data.identity
      })
    }
  }

  const handleOtherInfo = ({ id, data }) => {
    if (id === 'product_select') {
      return selectedProduct?.identity;
    }
  }

  const handleSettings = ({ component, condition }) => {
    if (component === 'table') {
      const updateData = handleTableQuery(productList, condition);
      setSortProductList(updateData);
    }
  }

  return (
    <>
      <Box mt={1} mb={1}>
        <Stack variant='start-center'>
          <Tooltip title="回上一頁" placement="bottom-start">
            <IconButton
              variant='fill-primary'
              size='small'
              onClick={() => navigate(PAGE.marketingword.path)}
            >
              <NavigateBeforeIcon />
            </IconButton>
          </Tooltip>
          <Typography variant='h3' m={2} sx={{ color: theme.palette.grey.w700 }}>選擇商品</Typography>
        </Stack>

        <SelectProduct
          selectedProduct={selectedProduct}
          setSelectedProduct={setSelectedProduct}
          searchKeyword={searchKeyword}
          setSearchKeyword={setSearchKeyword}
          handelSearchActive={handelSearchActive}
          handelSearchKeyDown={handelSearchKeyDown}
        />
      </Box>
      <NormalTable
        userAuth={{ role: 'admin' }}
        isPagination={true}
        size='small'
        tableColumnsDefined={currentTableColumnsDefined}
        tableData={{
          page: {
            total_page: pagination.total_page,
            size_total: pagination.total_entries,
          },
          data: sortProductList
        }}
        handleSettings={handleSettings}
        handleTableAction={handleTableAction}
        handleOtherInfo={handleOtherInfo}
        searchKeyword={searchKeyword}
        isLoading={isLoading}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        page={page}
        setPage={setPage}
        isMoblie={isMoblie}
      />
      <Loading
        variant='inside'
        invisibleBg={true}
        isLoading={isLoading}
        content={LOADING_MSG}
      />
    </>
  )
}

export default ProductList;